<template>
    <div>
        <el-tabs v-model="activeTab" @tab-click="onTabClick">
            <!-- ===== 系统通知 ===== -->
            <el-tab-pane label="系统通知" name="notice">
                <!-- 工具栏 -->
                <div style="margin-bottom: 5px;">
                    <el-input v-model="keyword" placeholder="请输入标题 / 发送人" suffix-icon="el-icon-search" style="width: 220px;"
                              @keyup.enter.native="loadPost"></el-input>
                    <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
                    <el-button type="success" @click="resetParam">重置</el-button>
                    <el-button type="primary" style="margin-left: 10px;" @click="openSend">发送通知</el-button>
                </div>

                <!-- 通知列表 -->
                <el-table :data="tableData"
                          :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                          border>
                    <el-table-column prop="id" label="ID" width="70"></el-table-column>
                    <el-table-column prop="title" label="标题" min-width="160"></el-table-column>
                    <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="senderName" label="发送人" width="110"></el-table-column>
                    <el-table-column label="发送时间" width="160">
                        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
                    </el-table-column>
                    <el-table-column label="阅读状态" width="130">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.allRead ? 'success' : (scope.row.readCount > 0 ? 'warning' : 'info')"
                                    disable-transitions>
                                {{ scope.row.readCount }}/{{ scope.row.totalCount }} 已读
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button size="small" type="primary" @click="openDetail(scope.row)">详情</el-button>
                            <el-popconfirm title="确定删除该通知吗？删除后用户将无法查看。"
                                           @confirm="del(scope.row)"
                                           style="margin-left: 5px;">
                                <el-button slot="reference" size="small" type="danger">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[5, 10, 20, 30]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </el-tab-pane>

            <!-- ===== 帮助反馈 ===== -->
            <el-tab-pane label="帮助反馈" name="feedback">
                <div style="margin-bottom: 5px;">
                    <el-input v-model="fbKeyword" placeholder="请输入用户 / 反馈内容" suffix-icon="el-icon-search"
                              style="width: 220px;" @keyup.enter.native="loadFb"></el-input>
                    <el-button type="primary" style="margin-left: 5px;" @click="loadFb">查询</el-button>
                    <el-button type="success" @click="fbKeyword = ''">重置</el-button>
                    <span style="margin-left: 10px; color: #c78ca6; font-size: 12px;">用户提交的反馈在此查看，处理完成后点"确定"即可</span>
                </div>

                <el-table :data="fbData"
                          :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                          border>
                    <el-table-column prop="id" label="ID" width="70"></el-table-column>
                    <el-table-column label="用户" width="140">
                        <template slot-scope="scope">{{ scope.row.userName }}（{{ scope.row.userNo }}）</template>
                    </el-table-column>
                    <el-table-column prop="content" label="反馈内容" min-width="240" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态" width="100">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status === 'completed' ? 'success' : 'warning'" disable-transitions>
                                {{ scope.row.status === 'completed' ? '已完成' : '待处理' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="提交时间" width="165">
                        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
                    </el-table-column>
                    <el-table-column label="完成时间" width="165">
                        <template slot-scope="scope">
                            {{ scope.row.finishTime ? formatTime(scope.row.finishTime) : '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="110">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status !== 'completed'" size="small" type="success"
                                       @click="finishFb(scope.row)">确定</el-button>
                            <span v-else class="fb-done">已处理</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="fbSizeChange"
                        @current-change="fbCurrentChange"
                        :current-page="fbPageNum"
                        :page-sizes="[5, 10, 20, 30]"
                        :page-size="fbPageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="fbTotal">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>

        <!-- 发送通知弹窗 -->
        <el-dialog title="🌸 发送系统通知" :visible.sync="sendVisible" width="560px"
                   custom-class="notice-send-dialog" append-to-body
                   @closed="resetSendForm">
            <el-form ref="sendForm" :rules="sendRules" :model="sendForm" label-width="90px">
                <el-form-item label="通知标题" prop="title">
                    <el-input v-model="sendForm.title" maxlength="100" show-word-limit
                              placeholder="请输入通知标题"></el-input>
                </el-form-item>
                <el-form-item label="通知内容" prop="content">
                    <el-input v-model="sendForm.content" type="textarea" :rows="5" maxlength="1000" show-word-limit
                              placeholder="请输入通知内容"></el-input>
                </el-form-item>
                <el-form-item label="接收对象">
                    <el-checkbox v-model="sendForm.allUsers" @change="onAllUsersChange">发送给全部用户</el-checkbox>
                    <div v-if="!sendForm.allUsers" style="margin-top: 6px;">
                        <el-select v-model="sendForm.userNos" multiple filterable collapse-tags clearable
                                   placeholder="请选择接收用户（可多选）" style="width: 100%;">
                            <el-option v-for="u in userOptions" :key="u.no"
                                       :label="u.name + '（' + u.no + '）'" :value="u.no"></el-option>
                        </el-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.6; margin-top: 4px;">
                            通知会自动排除发送人本人
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sendVisible = false">取 消</el-button>
                <el-button type="primary" :loading="sending" @click="doSend">发 送</el-button>
            </span>
        </el-dialog>

        <!-- 通知详情弹窗：含每个接收人的已读状态 -->
        <el-dialog :title="detail.noticeTitle ? '通知详情：' + detail.noticeTitle : '通知详情'" :visible.sync="detailVisible"
                   width="660px" append-to-body>
            <div v-if="detail.notice" class="notice-detail-block">
                <div class="detail-content">{{ detail.notice.content }}</div>
                <div class="detail-meta">
                    发送人：{{ detail.notice.senderName || '系统' }} · 发送时间：{{ formatTime(detail.notice.createTime) }}
                </div>
            </div>
            <el-table :data="detail.recipients"
                      :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                      border size="mini" max-height="320">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="userNo" label="账号" width="150"></el-table-column>
                <el-table-column prop="userName" label="姓名" width="130"></el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isRead === 'Y' ? 'success' : 'info'" disable-transitions>
                            {{ scope.row.isRead === 'Y' ? '已读' : '未读' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="阅读时间" min-width="170">
                    <template slot-scope="scope">
                        {{ scope.row.isRead === 'Y' ? formatTime(scope.row.readTime) : '—' }}
                    </template>
                </el-table-column>
            </el-table>
            <div style="color: #999; font-size: 12px; margin-top: 8px; text-align: right;">
                共 {{ detail.totalCount }} 人，已读 {{ detail.readCount }} 人
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { sendNotice, manageNotices, noticeDetail, deleteNotice } from '../../api/notice'
    import { manageFeedbacks, finishFeedback } from '../../api/feedback'
    import { formatTime } from '../../utils/format'

    export default {
        name: "NoticeManage",
        data() {
            return {
                activeTab: 'notice',
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                // 列表
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                keyword: '',
                // 帮助反馈
                fbData: [],
                fbPageSize: 10,
                fbPageNum: 1,
                fbTotal: 0,
                fbKeyword: '',
                // 发送弹窗
                sendVisible: false,
                sending: false,
                sendForm: {
                    title: '',
                    content: '',
                    allUsers: false,
                    userNos: []
                },
                sendRules: {
                    title: [
                        { required: true, message: '请输入通知标题', trigger: 'blur' },
                        { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入通知内容', trigger: 'blur' }
                    ]
                },
                userOptions: [],
                // 详情弹窗
                detailVisible: false,
                detail: {
                    noticeTitle: '',
                    notice: null,
                    recipients: [],
                    readCount: 0,
                    totalCount: 0
                }
            }
        },
        methods: {
            formatTime,
            resetParam() {
                this.keyword = ''
            },
            openSend() {
                this.sendVisible = true
                this.loadUsers()
            },
            onAllUsersChange(val) {
                if (val) {
                    this.sendForm.userNos = []
                }
            },
            resetSendForm() {
                this.sendForm = { title: '', content: '', allUsers: false, userNos: [] }
                this.$refs.sendForm && this.$refs.sendForm.clearValidate()
            },
            // 接收用户候选（管理员按后端权限只能看到普通用户；超管可看到全部）
            loadUsers() {
                if (this.userOptions.length) return
                this.$axios.post(this.$httpUrl + '/user/listPageC1', {
                    pageSize: 1000,
                    pageNum: 1,
                    param: {
                        name: '',
                        roleId: '',
                        operatorRole: this.user.roleId + ''
                    }
                }).then(res => res.data).then(res => {
                    if (res.code === 200) {
                        const list = res.data || []
                        // 排除发送人本人
                        this.userOptions = list.filter(u => u.no !== this.user.no)
                    }
                }).catch(() => {
                    this.$message.error('获取用户列表失败，请稍后重试')
                })
            },
            doSend() {
                this.$refs.sendForm.validate((valid) => {
                    if (!valid) return
                    if (!this.sendForm.allUsers && (!this.sendForm.userNos || !this.sendForm.userNos.length)) {
                        this.$message.warning('请选择接收用户，或勾选“发送给全部用户”')
                        return
                    }
                    this.sending = true
                    sendNotice({
                        title: this.sendForm.title.trim(),
                        content: this.sendForm.content,
                        userNos: this.sendForm.userNos,
                        allUsers: this.sendForm.allUsers,
                        senderNo: this.user.no,
                        senderName: this.user.name,
                        senderRole: Number(this.user.roleId)
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('通知发送成功，共发送给 ' + (res.data ? res.data.count : 0) + ' 位用户')
                            this.sendVisible = false
                            this.loadPost()
                        } else {
                            this.$message.error(res.msg || '发送失败')
                        }
                    }).catch(err => {
                        this.$message.error(err.message || '网络异常，请稍后重试')
                    }).finally(() => {
                        this.sending = false
                    })
                })
            },
            openDetail(row) {
                this.detail = {
                    noticeTitle: row.title,
                    notice: null,
                    recipients: [],
                    readCount: 0,
                    totalCount: 0
                }
                this.detailVisible = true
                noticeDetail(row.id).then(res => {
                    if (res.code === 200) {
                        const data = res.data || {}
                        this.detail.notice = data.notice || null
                        this.detail.recipients = data.recipients || []
                        this.detail.readCount = data.readCount || 0
                        this.detail.totalCount = data.totalCount || 0
                    } else {
                        this.$message.error(res.msg || '获取详情失败')
                    }
                }).catch(() => {
                    this.$message.error('获取详情失败，请稍后重试')
                })
            },
            del(row) {
                deleteNotice({
                    id: row.id,
                    operatorRole: this.user.roleId,
                    operatorNo: this.user.no,
                    operatorName: this.user.name
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.loadPost()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                }).catch(() => {
                    this.$message.error('网络异常，请稍后重试')
                })
            },
            loadPost() {
                manageNotices({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: { keyword: this.keyword }
                }).then(res => {
                    if (res.code === 200) {
                        this.tableData = res.data || []
                        this.total = Number(res.total || 0)
                    } else {
                        this.$message.error(res.msg || '获取数据失败')
                    }
                }).catch(() => {
                    this.$message.error('网络异常，请稍后重试')
                })
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            // ===== 帮助反馈 =====
            onTabClick(tab) {
                if (tab && tab.name === 'feedback' && !this.fbData.length) {
                    this.loadFb()
                }
            },
            loadFb() {
                manageFeedbacks({
                    pageSize: this.fbPageSize,
                    pageNum: this.fbPageNum,
                    param: { keyword: this.fbKeyword }
                }).then(res => {
                    if (res.code === 200) {
                        this.fbData = res.data || []
                        this.fbTotal = Number(res.total || 0)
                    } else {
                        this.$message.error(res.msg || '获取反馈失败')
                    }
                }).catch(() => {
                    this.$message.error('网络异常，请稍后重试')
                })
            },
            fbSizeChange(val) {
                this.fbPageNum = 1
                this.fbPageSize = val
                this.loadFb()
            },
            fbCurrentChange(val) {
                this.fbPageNum = val
                this.loadFb()
            },
            finishFb(row) {
                this.$confirm('确定处理完成该反馈吗？完成后用户将看到"已完成"状态。', '处理反馈', {
                    confirmButtonText: '确 定',
                    cancelButtonText: '取 消',
                    type: 'success'
                }).then(() => {
                    finishFeedback({
                        id: row.id,
                        operatorRole: Number(this.user.roleId),
                        operatorNo: this.user.no,
                        operatorName: this.user.name
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('反馈已处理完成')
                            this.loadFb()
                        } else {
                            this.$message.error(res.msg || '处理失败')
                        }
                    }).catch(() => {
                        this.$message.error('网络异常，请稍后重试')
                    })
                }).catch(() => {})
            }
        },
        beforeMount() {
            this.loadPost()
        }
    }
</script>

<style scoped>
    .notice-detail-block {
        padding: 6px 4px 14px;
    }

    .detail-content {
        font-size: 14px;
        line-height: 1.9;
        color: #5a4450;
        white-space: pre-wrap;
        word-break: break-word;
        padding: 14px;
        border-radius: 12px;
        background: #fff7fb;
        border: 1px solid #ffe0ef;
        margin-bottom: 10px;
    }

    .detail-meta {
        font-size: 12px;
        color: #b07790;
    }

    .fb-done {
        color: #b07790;
        font-size: 13px;
    }
</style>
